import { useCallback, useEffect, useState } from "react"
import { TimePicker as AntdTimePicker } from "antd"
import locale from "antd/es/date-picker/locale/ar_EG"
import { useSelector } from "react-redux"
import DateTime from "utils/dateTime"
import styles from "./index.module.less"
import cx from "clsx"

const TimePicker = props => {
  const { preSelectedDate, value, onChange, minuteStep = 5, isTimeDisabled = true, className, ...rest } = props
  const [startTime, setStartTime] = useState()
  const [endTime, setEndTime] = useState()
  const { locale: appLanguage } = useSelector(state => state.app.configs)

  useEffect(() => {
    if (value) {
      setStartTime(value[0])
      setEndTime(value[1])
    }
  }, [value])

  const range = (start, end) => {
    const result = []
    for (let i = start; i < end; i++) {
      result.push(i)
    }
    return result
  }

  const disabledTime = useCallback(
    (date, type) => {
      if (date && preSelectedDate && DateTime.isSameDay(preSelectedDate, date)) {
        return {
          disabledHours: () => {
            const hour =
              type === "end" && startTime ? DateTime.getHourFromDate(startTime) : DateTime.getHourFromDate(date)
            return range(0, hour)
          },
          disabledMinutes: selectedHour => {
            const comparisonHour = DateTime.getHourFromDate(startTime) || DateTime.getHourFromDate(date)
            if (type === "end") {
              if (selectedHour < comparisonHour) {
                return range(0, 59)
              }
              if (selectedHour === comparisonHour) {
                const minutes = startTime ? DateTime.getMinutesFromDate(startTime) : DateTime.getMinutesFromDate(date)
                return range(0, minutes)
              }
            } else {
              const dateHour = DateTime.getHourFromDate(date)
              if (selectedHour < dateHour) {
                return range(0, 59)
              }
              if (selectedHour === dateHour) {
                return range(0, DateTime.getMinutesFromDate(date))
              }
            }
            return []
          },
        }
      } else if (isTimeDisabled && type === "end" && startTime) {
        return {
          disabledHours: () => {
            const hour = DateTime.getHourFromDate(startTime)
            return range(0, hour)
          },
          disabledMinutes: () => {
            const minutes = DateTime.getMinutesFromDate(startTime)
            return range(0, minutes)
          },
        }
      }
      return {
        disabledHours: () => [],
        disabledMinutes: () => [],
      }
    },
    [preSelectedDate, startTime, isTimeDisabled]
  )

  const handleChangeTime = dates => {
    if (dates) {
      let edTime = dates[1]
      let stTime = DateTime.getDateAndTime(dates[0])
      if (isTimeDisabled) {
        if (
          DateTime.isAfterMentionedDate(stTime, dates[1]) &&
          DateTime.isSameDay(DateTime.getHoursAfterDateProvided(DateTime.getDateAndTime(stTime), 1), stTime)
        ) {
          edTime = DateTime.getHoursAfterDateProvided(stTime, 1)
        } else if (
          DateTime.isAfterMentionedDate(stTime, dates[1]) &&
          !DateTime.isSameDay(DateTime.getHoursAfterDateProvided(DateTime.getDateAndTime(stTime), 1), stTime)
        ) {
          edTime = DateTime.getEndOfDay(stTime)
        }
      }
      setEndTime(edTime)
      // onChange([dates[0], edTime])
    }
  }

  return (
    <AntdTimePicker.RangePicker
      order={false}
      use12Hours
      format="h:mm a"
      disabledTime={disabledTime}
      value={[startTime, endTime]}
      onChange={dates => {
        if (dates) {
          handleChangeTime(dates)
        } else {
          setStartTime(null)
          setEndTime(null)
          onChange([null, null])
        }
      }}
      onOk={dates => {
        onChange(dates)
        setStartTime(dates[0])
        setEndTime(dates[1])
      }}
      hideDisabledOptions
      minuteStep={minuteStep}
      // locale={appLanguage === "en" ? [] : locale}
      className={cx(styles.timePicker, className)}
      {...rest}
    />
  )
}
export default TimePicker
